import { render, staticRenderFns } from "./PostDocPc.vue?vue&type=template&id=1e9880e6&scoped=true&"
import script from "./PostDocPc.vue?vue&type=script&lang=js&"
export * from "./PostDocPc.vue?vue&type=script&lang=js&"
import style0 from "./PostDocPc.vue?vue&type=style&index=0&id=1e9880e6&prod&scoped=true&lang=css&"
import style1 from "./PostDocPc.vue?vue&type=style&index=1&id=1e9880e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9880e6",
  null
  
)

export default component.exports